import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "toggler"]

  toggle(_e) {
    if (this.passwordTarget.type === "password") {
      this.togglerTarget.classList = "bi-eye-slash"
      this.passwordTarget.type = "text"
    } else {
      this.togglerTarget.classList = "bi-eye"
      this.passwordTarget.type = "password"
    }
  }
}
